import { GetStrTotal } from '../Functions/GetStrTotal.js';
import { CreatedAt } from '../Document/CreatedAt.js';

export const BlockTitleDate1Link0 = (props) => {
    /*
    Pages/Public/ArchivesAttractions.js
    Pages/Public/Characters.js
    Pages/Public/Festivals.js
    Pages/Public/Origins.js
    Pages/Public/Outlinks.js
    Pages/Public/Park.js
    Pages/Public/RendezVous.js
    */
    const { label, items } = props;
    const { name, author, created, total } = items;
    let cname, strTotal;
    switch (label) {
        case 'archives':
        case 'characters':
        case 'festivals':
        case 'origins':
        case 'outlinks':
        case 'park':
            if (label === 'archives') cname = 'attraction';
            if (label === 'characters') cname = 'personnage';
            if (label === 'festivals') cname = 'parade';
            if (label === 'origins') cname = 'origine';
            if (label === 'outlinks') cname = 'lien';
            if (label === 'park') cname = 'attraction';
            strTotal = `${total} ${GetStrTotal(cname, total)}`;
            return (
                <div className="block-title">
                    <CreatedAt date={created} />
                    <div className="title">
                        <div className="title-name">{name}</div>
                        <div className="title-total-label">{strTotal}</div>
                        <div className="title-author">{author}</div>
                    </div>
                </div>
            )
        default:
            return (
                <></>
            )
    }
}